import { Button, Form, Image, Input, Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import MediaManager from '../../Media/MediaManager';
import { useForm } from 'antd/es/form/Form';
import { useCategorys } from './CatStore';
import { MAIN_URL } from '../../../Constants';

function Add(props) {
    let { createCategory } = useCategorys()
    let [icon, setIcon] = useState(null)
    let [previewVisible, setPreviewVisible] = useState(false)
    let handleSelect = (e) => {
        setIcon(e)
        setPreviewVisible(false)
    }
    let [form] = useForm();
    useEffect(() => {
        form.setFieldsValue({
            icon: icon
        })
    }, [icon])

    return (
        <>
            <Modal open={previewVisible} footer={null} onCancel={() => setPreviewVisible(false)}>
                <MediaManager onSelect={handleSelect} />
            </Modal>
            <Form form={form} layout="vertical" onFinish={(values) => {createCategory(values); form.resetFields()}} encType="multipart/form-data">
                <Form.Item label="O'zbekcha nomi" name="nameuz" rules={[{ required: true, message: 'Please input your name!' }]}>
                    <Input />
                </Form.Item>
                <Form.Item label="Ruscha nomi" name="nameru" rules={[{ required: true, message: 'Please input your description!' }]}>
                    <Input />
                </Form.Item>
                <Form.Item label="Ikonka" name="icon">
                    <Input readOnly suffix={<Button type="primary" onClick={() => setPreviewVisible(true)}>Fayl yuklash</Button>} />
                </Form.Item>
                {icon && <Image src={MAIN_URL + '/' + icon} width={100} height={100} style={{objectFit: 'cover'}} />}
                <Form.Item>
                    <Button type="primary" htmlType="submit">Qo'shish</Button>
                </Form.Item>
            </Form>
        </>
    );
}

export default Add;